import { render, staticRenderFns } from "./VaccinationAbsoluteDataPanel.vue?vue&type=template&id=8c79fc7c&scoped=true&"
import script from "./VaccinationAbsoluteDataPanel.vue?vue&type=script&lang=js&"
export * from "./VaccinationAbsoluteDataPanel.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationAbsoluteDataPanel.vue?vue&type=style&index=0&id=8c79fc7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c79fc7c",
  null
  
)

export default component.exports